import React from 'react';
import styled from "styled-components";
import ErrorPage from './ErrorPage';

const Style = styled.div`
  margin-top: 120px;
`
class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return (
          <ErrorPage />
        ); 
      }
  
      return this.props.children; 
    }
}

export default ErrorBoundary